import React, { Component } from "react";
import PropTypes from "prop-types";
import { Mutation } from "react-apollo";
import { Button, Fieldset, Field, Control } from "rbx";

import { CREATE_LOCATION_CONTACT_MUTATION } from "../../graphql/Locations/LocationContacts.graphql";

import { ourToast as toast } from "../../utils";

import LocationContactForm from "./LocationContactForm";

import Section from "../Section";

class AddLocationContactForm extends Component {
  state = {
    IsPrimary: false,
    Description: "",
    Name: "",
    Telephone: "",
    Extension: "",
    FaxNo: "",
    Email: "",
    Active: true
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const { id, onComplete } = this.props;
    const {
      IsPrimary,
      Description,
      Name,
      Telephone,
      Extension,
      FaxNo,
      Email,
      Active
    } = this.state;
    return (
      <Mutation
        mutation={CREATE_LOCATION_CONTACT_MUTATION}
        refetchQueries={["ALL_LOCATION_CONTACTS_QUERY"]}
        variables={{
          data: {
            LocationRecIdRef: id,
            IsPrimary,
            Description,
            Name,
            Telephone,
            Extension,
            FaxNo,
            Email,
            Active
          }
        }}
      >
        {(createLocationContact, { loading, error }) => (
          <Section title="Add Location Contact">
            <form
              id="add-location-contact"
              onSubmit={async e => {
                e.preventDefault();
                try {
                  await createLocationContact();
                  onComplete();
                } catch (err) {
                  toast.error("Error creating Location Contact.");
                }
              }}
            >
              <Fieldset disabled={loading}>
                <LocationContactForm
                  inputs={{
                    LocationRecIdRef: id,
                    IsPrimary,
                    Description,
                    Name,
                    Telephone,
                    Extension,
                    FaxNo,
                    Email,
                    Active
                  }}
                  onChange={this.onChange}
                />
                <hr />
                <Field kind="group">
                  <Control>
                    <Button color="primary" type="submit">
                      Submit
                    </Button>
                  </Control>
                  <Control>
                    <Button type="button" onClick={onComplete}>
                      Cancel
                    </Button>
                  </Control>
                </Field>
              </Fieldset>
            </form>
          </Section>
        )}
      </Mutation>
    );
  }
}

AddLocationContactForm.propTypes = {
  id: PropTypes.number.isRequired,
  onComplete: PropTypes.func
};
export default AddLocationContactForm;
